import script from "./MyPage.vue?vue&type=script&setup=true&lang=js"
export * from "./MyPage.vue?vue&type=script&setup=true&lang=js"

import "./MyPage.vue?vue&type=style&index=0&id=2098bc2f&scoped=true&lang=css"

import exportComponent from "/home/jenkins/storybird-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2098bc2f"]])

export default __exports__